import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import type { AssignmentStatus } from './types';

dayjs.locale('ru');
dayjs.extend(utc);
dayjs.extend(timezone);

export const STATUS: Record<AssignmentStatus, { label: string; color: string }> = {
  NOT_STARTED: { label: 'Не начат', color: 'gray' },
  IN_PROGRESS: { label: 'В процессе', color: 'blue' },
  RETAKE: { label: 'Требуется пересдача', color: 'orange' },
  BLOCKED: { label: 'Заблокирован', color: 'red' },
  COMPLETED: { label: 'Завершён', color: 'teal' },
  COMPLETED_LATE: { label: 'Завершён с опозданием', color: 'yellow' },
  OVERDUE: { label: 'Просрочен', color: 'red' },
  CANCELLED: { label: 'Отменён', color: 'dark' },
};

export const DONE: AssignmentStatus[] = ['COMPLETED', 'COMPLETED_LATE'];

export const fmtDate = (d: string | Date | null | undefined, tz?: string | null) => (d ? (tz ? dayjs(d).tz(tz) : dayjs(d)).format('D MMM YYYY') : '-');
export const fmtDateTime = (d: string | Date | null | undefined, tz?: string | null) => (d ? (tz ? dayjs(d).tz(tz) : dayjs(d)).format('D MMM YYYY, HH:mm') : '-');

export function dueLabel(dueAt: string, done: boolean): { text: string; color: string } {
  if (done) return { text: `Срок ${fmtDate(dueAt)}`, color: 'dimmed' };
  const days = dayjs(dueAt).startOf('day').diff(dayjs().startOf('day'), 'day');
  if (dayjs(dueAt).isBefore(dayjs())) return { text: `Срок прошёл ${fmtDate(dueAt)}`, color: 'red' };
  if (days === 0) return { text: 'Срок сегодня до конца дня', color: 'orange' };
  if (days <= 3) return { text: `Осталось ${days} дн.`, color: 'orange' };
  return { text: `До ${fmtDate(dueAt)}`, color: 'dimmed' };
}

export const score = (correct: number | null | undefined, of: number | null | undefined) => (correct == null ? '-' : `${correct}/${of}`);
